import React from 'react'

import EditableItemFooter from './EditableItemFooter'
import OwnBookingFooter from './OwnBookingFooter'
import ReadOnlyItemFooter from './ReadOnlyItemFooter'

import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId } from 'selectors/accountSelectors'
import { AirbnbItem, HotelItem } from 'tripPlanner/types/tripItem'
import { getOrderId, isHotel, isLeBooking } from 'tripPlanner/utils'

interface Props {
  item: AirbnbItem | HotelItem
}

export default function AccommodationSummaryModalFooter({ item }: Props) {
  const orderId = isHotel(item) ? getOrderId(item) : undefined
  const userId = useAppSelector(getCurrentUserId)

  if (isLeBooking(item) && orderId) {
    if (item.createdBy === userId) {
      return <OwnBookingFooter item={item} orderId={orderId} />
    } else {
      return <ReadOnlyItemFooter item={item} />
    }
  } else {
    return <EditableItemFooter item={item} />
  }
}
